/* Reminders go out at the user's chosen time in users.timezone, so the
   server needs the phone's real zone. Without it everyone stayed on the
   Europe/Rome default and New York got the 19:00 reminder at 1pm. */

const REPORTED_KEY = 'bh_reported_timezone';

export function deviceTimezone() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || null;
  } catch (_) {
    return null;
  }
}

export function rememberReportedTimezone(zone) {
  try { localStorage.setItem(REPORTED_KEY, zone); } catch (_) {}
}

/* The zone to save for this user, or null. The phone's zone is reported when
   it differs from the stored one and from what this device last reported, so
   a zone picked in Edit Profile sticks until the phone's own zone changes. */
export function timezoneToReport(storedZone) {
  const zone = deviceTimezone();
  if (!zone) return null;
  if (zone === storedZone) {
    rememberReportedTimezone(zone);
    return null;
  }
  let last = null;
  try { last = localStorage.getItem(REPORTED_KEY); } catch (_) {}
  return zone === last ? null : zone;
}
